import React, {useContext, useEffect, useMemo, useState} from 'react';
import {SlideContent} from '../menu/Menu'
import FormattedNumber, { formatNumber } from "./FormattedNumber";
import { getLabel } from '../functions/lang';

import {getIndicatorKey, listSlide} from "../functions";
import {getCountries} from "../functions";
import MultiLingualContent, { getText } from "../config/multilingualContent";
import {LanguageContext} from "../config/multilingualContext";
import { SelectedCountryContext } from '../contexts/SelectedCountryContext';

import Slider from "react-slick";
import '../assets/css/slide.css'
import '../assets/css/countryPicker.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import {endpointImg} from "../api";
import { SelectPicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

// Icônes pour les flèches (vous pouvez aussi utiliser une librairie d'icônes)
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow next-arrow" onClick={onClick}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 18l6-6-6-6"/>
    </svg>
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow prev-arrow" onClick={onClick}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M15 18l-6-6 6-6"/>
    </svg>
  </div>
);

const settings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000, // 5 secondes entre chaque slide
  fade: true,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        dots: true
      }
    }
  ]
};

const Slide = () => {
  const {language} = useContext(LanguageContext);
  const [isloading, setIsloading] = useState(false);
  const [slides, setSlides] = useState([]);
  const [allIndKey, setAllIndKey] = useState([]);
  const [countries, setCountries] = useState([]);
  const pickerData = useMemo(() => {
    return countries.map(item => ({
      label: {
        french: item.label_fr ?? "",
        english: item.label_en ?? "",
        portuguais: item.label_pr ?? "",
        swahili: item.label_sw ?? "",
      }[language],
      value: String(item.id),
      role: {
        french: item.label_fr ?? "",
        english: item.label_en ?? "",
        portuguais: item.label_pr ?? "",
        swahili: item.label_sw ?? "",
      }[language],
    })).sort((a, b) => (a.label || "").localeCompare(b.label || "", language === 'french' ? 'fr' : language === 'english' ? 'en' : language === 'portuguais' ? 'pt' : 'sw', { sensitivity: 'base' }))
  }, [countries, language]);
  const { selectedCountryId, setSelectedCountryId } = useContext(SelectedCountryContext);
  const selectedCountry = selectedCountryId ? String(selectedCountryId) : '';
  const applyCountrySelection = (val) => {
    if (!val) return;
    setSelectedCountryId(String(val));
  };

  useEffect(() => {
  async function getSlides() {
      setIsloading(true);
      try {
        const response = await listSlide()
    const indKey = await getIndicatorKey(selectedCountryId || undefined)
        const {status, code, data} = await indKey;
        setSlides(response);
        setAllIndKey(data);
      } catch (error) {
        console.error(error);
      }
  // load countries for picker
  const countriesRes = await getCountries();
  
  setCountries(countriesRes || []);
      setIsloading(false);
    }

    getSlides()
  }, [])

  // Refetch indicator keys when country changes
  useEffect(() => {
    (async () => {
      try {
        const indKey = await getIndicatorKey(selectedCountryId || undefined);
        const { status, code, data } = await indKey;
        setAllIndKey(data);
      } catch (err) {
        console.error('getIndicatorKey failed', err);
      }
    })();
  }, [selectedCountryId])

  // Ensure a valid selected country when countries list becomes available
  useEffect(() => {
    if (!countries || countries.length === 0) return;
  const exists = countries.some(c => String(c.id) === String(selectedCountry));
  if (!exists || !selectedCountry) {
      const principal = countries.find(c => c.isPrincipal === true || c.isPrincipal === 1 || c.isPrincipal === '1');
      const fallbackId = principal ? String(principal.id) : String(countries[0].id);
      applyCountrySelection(fallbackId);
    }
  }, [countries])

  // Sync when selectedCountryId changes (e.g., set by another component or fallback)
  useEffect(() => {
    if (!selectedCountryId && countries.length > 0) {
      const principal = countries.find(c => c.isPrincipal === true || c.isPrincipal === 1 || c.isPrincipal === '1');
      const fallbackId = principal ? String(principal.id) : String(countries[0].id);
      applyCountrySelection(fallbackId);
    }
  }, [selectedCountryId, countries])

  return (
    <div className="slide-modern-container">
      {isloading ? (
        <div className="loading-container">
          <span className="loading-placeholder"></span>
        </div>
      ) : (
        <div className="slide-modern-wrapper">
          {countries.length > 1 && (
            <div className="sticky-country-picker" role="region" aria-label="Country selector">
              <div className="picker-left">
                {/*<span className="picker-label"><MultiLingualContent contentID="country"/></span>*/}
                <SelectPicker
                  data={pickerData}
                value={selectedCountry}
                onChange={applyCountrySelection}
                cleanable={false}
                searchable
                placement="bottomStart"
                style={{ width: 240 }}
              />
            </div>
            <div className="picker-right" aria-live="polite">
              {(() => {
                const c = countries.find(x => String(x.id) === String(selectedCountry));
                if (!c) return null;
                const nameByLang = {
                  french: c.label_fr ?? c.name ?? '',
                  english: c.label_en ?? c.name ?? '',
                  portuguais: c.label_pr ?? c.name ?? '',
                  swahili: c.label_sw ?? c.name ?? ''
                }[language];
                return (
                  <div className="picker-active-country" title={nameByLang}>
                    <span className="picker-hint">
                      {getText('countryPickerHint', language)}
                    </span>
                  </div>
                );
              })()}
            </div>
          </div>)}
          <div className="slide-main-section">
            {/* Slider */}
            <div className="slider-container">
              <Slider {...settings}>
                {slides?.length > 0 ? (
                  slides.map((item, index) => (
                    <div key={index} className="slide-item">
                      <div
                        className="slide-image"
                        style={{
                          backgroundImage: `url(${endpointImg + item?.sampleImg})`,
                        }}
                      />
                      <div className="slide-caption">
                        <h3>{{
                          french : item.titleFr || "...",
                          english : item.titleEn || "...",
                          portugais : item.titlePr || "...",
                          swahili : item.titleSw || "..."
                        }[language]}</h3>
                        <p>{item.description || ""}</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="slide-item">
                    <div
                      className="slide-image"
                      style={{
                        backgroundImage: `url(${SlideContent.image})`,
                      }}
                    />
                    <div className="slide-caption">
                      <h3>Slide par défaut</h3>
                    </div>
                  </div>
                )}
              </Slider>
            </div>

            {/* Indicateurs clés - version desktop */}
            <div className="key-indicators-sidebar">
              <div className="indicators-header">
                <h3><MultiLingualContent contentID="keyind"/></h3>
                <div className="indicators-divider"></div>
              </div>
              <div className="indicators-grid">
                {allIndKey?.map((item, i) => {
                  const formattedValue = formatNumber(item.value, language, 2);
                  const label = getLabel({
                    label_fr: item.label_fr,
                    label_en: item.label_en,
                    label_pr: item.label_pr,
                    label_sw: item.label_sw
                  }, language);
                  const unit = getLabel({
                    unitlabel_fr: item.unit_label_fr,
                    unitlabel_en: item.unit_label_en,
                    unitlabel_pr: item.unit_label_pr,
                    unitlabel_sw: item.unit_label_sw,
                  }, language);

                  return (
                    <div className="indicator-card" key={i}>
                      <div className="indicator-value">
                        <span className="value-number">{formattedValue}</span>
                        {unit && <span className="value-unit">{unit}</span>}
                      </div>
                      <div className="indicator-label">{label}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>






          {/* Indicateurs clés - version mobile */}
          <div className="key-indicators-bottom">
            <div className="indicators-mobile-header">
              <h3><MultiLingualContent contentID="keyind"/></h3>
            </div>
            <div className="indicators-mobile-grid">
              {allIndKey?.map((item, i) => {
                const formattedValue = formatNumber(item.value, language, 2);
                const label = getLabel({
                  label_fr: item.label_fr,
                  label_en: item.label_en,
                  label_pr: item.label_pr,
                  label_sw: item.label_sw
                }, language);
                const unit = getLabel({
                  unitlabel_fr: item.unit_label_fr,
                  unitlabel_en: item.unit_label_en,
                  unitlabel_pr: item.unit_label_pr,
                  unitlabel_sw: item.unit_label_sw,
                }, language);

                return (
                  <div className="indicator-mobile-card" key={i}>
                    <div className="indicator-mobile-value">
                      <span className="mobile-value-number">{formattedValue}</span>
                      {unit && <span className="mobile-value-unit">{unit}</span>}
                    </div>
                    <div className="indicator-mobile-label">{label}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Slide;